import React, { useState, useEffect } from "react";
import { Box, getColor, Typography } from "fds";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import utilsCommon from "../../shared/utils/common";
import { useTranslation } from "react-i18next";
import config from "../../shared/config/config";
const Service: React.FC = () => {
  const navigate = useNavigate();
  const CUSTOM_SERVICE = window.eco.isCustomService;
  const GATEWAY_URL = config.servers.gateway.url;

  const { t } = useTranslation();
  const { i18n } = useTranslation();

  if (CUSTOM_SERVICE === true) {
    if (i18n.language === "ko") {
      window.location.href = `/service_info_ko.html`;
    } else {
      window.location.href = `/service_info_en.html`;
    }
  }

  const openGuide = (osName: string) => {
    const SERVICE_TYPE = window.eco.serviceType;
    switch (osName) {
      case "windows":
        if (
          SERVICE_TYPE &&
          (SERVICE_TYPE === "CLOUD" || SERVICE_TYPE === "cloud")
        ) {
          window.open(t("login.download.windowDownload"));
        } else {
          window.open(GATEWAY_URL + t("login.download.windowOnpremise"));
        }
        break;
      case "mac":
        if (
          SERVICE_TYPE &&
          (SERVICE_TYPE === "CLOUD" || SERVICE_TYPE === "cloud")
        ) {
          window.open(t("login.download.macDownload"));
        } else {
          window.open(GATEWAY_URL + t("login.download.macOnpremise"));
        }
        break;
      case "manager":
        if (
          SERVICE_TYPE &&
          (SERVICE_TYPE === "CLOUD" || SERVICE_TYPE === "cloud")
        ) {
          window.open(t("login.download.adminGuide"));
        } else {
          window.open(GATEWAY_URL + t("login.download.adminOnpremise"));
        }
        break;
      case "video":
        window.open(t("login.download.videoLink"));
        break;
    }
  };
  return CUSTOM_SERVICE ? (
    <div></div>
  ) : (
    <Box classes="service">
      <Box classes="service-left">
        <Box
          alignItems="center"
          maxWidth={497}
          direction="column"
          style={{ marginTop: "20%" }}
        >
          <img
            src={utilsCommon.renderWrapsodyECOLogo()}
            alt={"logo"}
            // height={76}
            width={306}
            className="service-left--logo cursor pointer"
            onClick={() => navigate(`${process.env.PUBLIC_URL}/login`)}
          />
          <img
            src={require("../../shared/images/pages/Signup/star.png")}
            alt={"logo"}
            className="service-left--star1"
          />
          <img
            src={require("../../shared/images/pages/Signup/star.png")}
            alt={"logo"}
            className="service-left--star2"
          />
          <Typography style={{ marginTop: "35px" }} type="h1">
            {t("login.service.title")}
          </Typography>
          <Typography
            type="body1_md"
            classes={"mg mt-20"}
            maxWidth={"90%"}
            textAlign={"center"}
            whiteSpace="break-spaces"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("login.service.info")}
          </Typography>

          <img
            src={require("../../shared/images/pages/Signup/people.png")}
            alt={"logo"}
            style={{ marginTop: 122 }}
          />
        </Box>
      </Box>
      <Box classes="service-right">
        <Box direction="column" classes="service-right--body">
          <Box alignItems="center" classes="edge">
            <img
              src={require("../../shared/images/pages/Signup/lock.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2" classes="h2" whiteSpace="break-spaces">
              {t("login.service.explain1_1")}
              <Typography
                type="h2"
                classes={"mg ml-4"}
                exactColor={getColor("COLOR_GREEN_60")}
              >
                {t("login.service.explain1_2")}
              </Typography>
              {t("login.service.explain1_3")}
              <Typography
                type="h2"
                classes={"mg ml-4"}
                exactColor={getColor("COLOR_GREEN_60")}
              >
                {t("login.service.explain1_4")}
              </Typography>
              {t("login.service.explain1_5")}
            </Typography>
          </Box>
          <Box alignItems="center">
            <img
              src={require("../../shared/images/pages/Signup/humans.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2">
              {t("login.service.explain2_1")}
              <Typography
                type="h2"
                classes={"mg ml-4 service-button"}
                exactColor={getColor("COLOR_GREEN_60")}
                onClick={() =>
                  navigate(
                    window.eco.serviceType === "OCI"
                      ? "/signup"
                      : "/checkSignup"
                  )
                }
              >
                {t("login.service.explain2_2")}
              </Typography>
              {t("login.service.explain2_3")}
            </Typography>
          </Box>
          <Box alignItems="center">
            <img
              src={require("../../shared/images/pages/Signup/human.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2">
              {t("login.service.explain3_1")}
              <Typography
                type="h2"
                classes={"mg ml-4 service-button"}
                exactColor={getColor("COLOR_GREEN_60")}
                onClick={() => navigate(`${process.env.PUBLIC_URL}/login`)}
              >
                {t("login.service.explain3_2")}
              </Typography>
              {t("login.service.explain3_3")}
            </Typography>
          </Box>
          <Box alignItems="center" height={52}>
            <img
              src={require("../../shared/images/pages/Signup/setting.png")}
              alt={"logo"}
              width={"64px"}
              height={"62px"}
            />
            <Typography type="h2">
              {t("login.service.explain4_1")}
              <Typography
                type="h2"
                classes={"mg ml-4 service-button"}
                exactColor={getColor("COLOR_GREEN_60")}
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/downloadClient`)
                }
              >
                {t("login.service.explain4_2")}
              </Typography>
              {t("login.service.explain4_3")}
            </Typography>
          </Box>
        </Box>

        <Box
          style={{ marginTop: 100 }}
          justifyContent="space-between"
          width={"calc(100% + 33px)"}
          classes="clientAndGuides"
        >
          <Box
            direction="column"
            alignItems="center"
            classes="clientAndGuide"
            onClick={() => navigate(`${process.env.PUBLIC_URL}/downloadClient`)}
          >
            <img
              src={require("../../shared/images/pages/Signup/osSetting.png")}
            />
            <Typography style={{ marginTop: 15 }} type="subtitle2">
              {t("login.download.downloadApp")}
            </Typography>
            <Typography
              type="body3_rg"
              classes="mg mt-2"
              textAlign="center"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("login.download.downloadAppDesc")}
            </Typography>
          </Box>
          <Box
            direction="column"
            alignItems="center"
            classes="clientAndGuide"
            onClick={() => openGuide("windows")}
          >
            <img
              src={require("../../shared/images/pages/Signup/windowsguide.png")}
            />
            <Typography
              style={{ marginTop: 15 }}
              type="subtitle2"
              textAlign="center"
            >
              {t("login.download.window")}
            </Typography>
            <Typography
              type="body3_rg"
              classes="mg mt-2"
              textAlign="center"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("login.download.windowsDesc")}
            </Typography>
          </Box>
          <Box
            direction="column"
            alignItems="center"
            classes="clientAndGuide"
            onClick={() => openGuide("mac")}
          >
            <img src={require("../../shared/images/pages/Signup/apple.png")} />
            <Typography
              style={{ marginTop: 15 }}
              type="subtitle2"
              textAlign="center"
            >
              {t("login.download.mac")}
            </Typography>
            <Typography
              type="body3_rg"
              classes="mg mt-2"
              textAlign="center"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("login.download.macDesc")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Service;
